export class Time {
    constructor() {
        this._hours = 0;
        this._minutes = 0;
        this._seconds = 0;
        this._raw = 0;
    }
    get Raw() {
        return this._raw;
    }
    get Hours() {
        return this._hours;
    }
    set Hours(value) {
        this._hours = value;
    }
    get Minutes() {
        return this._minutes;
    }
    set Minutes(value) {
        this._minutes = value;
    }
    get Seconds() {
        return this._seconds;
    }
    set Seconds(value) {
        this._seconds = value;
    }
}
export class StateOfTurnOnSwitchDeviceParameters {
    constructor() {
        this.Channel = 0;
        this.State = SwitchTurnOnState.Disabled;
    }
}
export var SwitchTurnOnState;
(function (SwitchTurnOnState) {
    SwitchTurnOnState[SwitchTurnOnState["Disabled"] = 0] = "Disabled";
    SwitchTurnOnState[SwitchTurnOnState["Enabled"] = 1] = "Enabled";
    SwitchTurnOnState[SwitchTurnOnState["PreviousState"] = 2] = "PreviousState";
})(SwitchTurnOnState || (SwitchTurnOnState = {}));
export class GlobalTimeParameters {
    constructor() {
        this.Channel = 0;
        this.Time = new Time();
    }
}
export class InputModeSwitchParams {
    constructor() {
        this.Channel = 0;
        this.InputChannel = 0;
        this.InputMode = InputModeSwitch.Bistable;
    }
}
export class ReactionToInputSwitchParams {
    constructor() {
        this.Channel = 0;
        this.InputChannel = 0;
        this.ReactionToInput = ReactionToInput.None;
    }
}
export var InputModeSwitch;
(function (InputModeSwitch) {
    InputModeSwitch[InputModeSwitch["Monostable"] = 0] = "Monostable";
    InputModeSwitch[InputModeSwitch["Bistable"] = 1] = "Bistable";
})(InputModeSwitch || (InputModeSwitch = {}));
export class InputOutputSwitchParameters {
    constructor() {
        this._channel = 0;
        this._inputsNumber = 0;
        this._inputMode = InputModeSwitch.Monostable;
        this._reactionToInput = ReactionToInput.None;
        this._inputChannel = 0;
    }
    get Channel() {
        return this._channel;
    }
    set Channel(value) {
        this._channel = value;
    }
    get InputsNumber() {
        return this._inputsNumber;
    }
    get InputMode() {
        return this._inputMode;
    }
    set InputMode(value) {
        this._inputMode = value;
    }
    get ReactionToInput() {
        return this._reactionToInput;
    }
    set ReactionToInput(value) {
        this._reactionToInput = value;
    }
    get InputChannel() {
        return this._inputChannel;
    }
    set InputChannel(value) {
        this._inputChannel = value;
    }
}
export var ReactionToInput;
(function (ReactionToInput) {
    ReactionToInput[ReactionToInput["None"] = 0] = "None";
    ReactionToInput[ReactionToInput["Off"] = 1] = "Off";
    ReactionToInput[ReactionToInput["On"] = 2] = "On";
    ReactionToInput[ReactionToInput["Time"] = 3] = "Time";
    ReactionToInput[ReactionToInput["Mono"] = 4] = "Mono";
    ReactionToInput[ReactionToInput["Bi"] = 5] = "Bi";
    ReactionToInput[ReactionToInput["OnOff"] = 6] = "OnOff";
})(ReactionToInput || (ReactionToInput = {}));
//# sourceMappingURL=OnOffSwitchParameters.js.map